export const homeSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Dance Embassy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dance Embassy is a Singapore-based dance and wellness studio offering Bollywood dance classes, fitness sessions, and team-building workshops. Established in 2012, it caters to individuals, corporates, and schools."
      }
    },
    {
      "@type": "Question",
      "name": "What types of classes are available?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dance Embassy offers Bollywood dance, fitness-based formats, virtual classes, and in-studio sessions for both beginners and experienced dancers."
      }
    },
    {
      "@type": "Question",
      "name": "How can I book a class?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can book a class by visiting the Booking section on the website, selecting your preferred slot, and making the payment. Confirmation will be sent via email."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer trial classes?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, trial classes are available. You can join a single session either in-studio or virtually to get a feel of the teaching style and format."
      }
    },
    {
      "@type": "Question",
      "name": "What packages are offered for classes?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Class packages include virtual and in-studio options. Packages are typically valid for 3 months and are non-transferable."
      }
    },
    {
      "@type": "Question",
      "name": "Are the instructors certified or trained?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, the instructors are experienced and known for their high-energy teaching style, offering a fun and engaging learning environment."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book Dance Embassy for private events or corporate workshops?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Dance Embassy conducts private sessions, wedding choreographies, and corporate team-building workshops tailored to your needs."
      }
    },
    {
      "@type": "Question",
      "name": "Where is Dance Embassy located?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dance Embassy is located in Singapore. Exact studio details, operating hours, and directions can be found on the website's contact or about page."
      }
    }
  ]
};

export const teamBuildingSchemafaq = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How do I book DE for a Corporate session?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Kindly fill up the contact form with the subject: “Free demo for Corporate”. A DE consultant will then reach out to discuss further. During this call, we aim to understand your needs and thus enabling us to ensure your session is a success."
      }
    },
    {
      "@type": "Question",
      "name": "What can I expect in a DE Team Building session?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can expect fun, engaging, and high-energy sessions tailored to your team’s needs. These include dance-based activities, team challenges, and bonding exercises to boost morale and collaboration."
      }
    },
    {
      "@type": "Question",
      "name": "I want to book more than one session, are there any packages available?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer customizable packages for multiple sessions. You can contact us directly for details and tailored options to suit your team size and goals."
      }
    },
    {
      "@type": "Question",
      "name": "Do you hold virtual team building workshops?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, DE offers virtual team building workshops that are interactive and designed to keep remote teams engaged and connected."
      }
    },
    {
      "@type": "Question",
      "name": "Are your team building workshops held in Singapore?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our physical team building workshops are held in Singapore. We also cater to international clients upon request."
      }
    },
    {
      "@type": "Question",
      "name": "What are your top recommended workshops?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our top workshops include Bollywood Dance, Afrobeat Groove, and Fitness Fusion — all designed to energize and engage your team."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer venues for your team building workshops?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we can provide venue options or conduct workshops at your preferred location. Contact us for venue arrangements and details."
      }
    }
  ]
}
export const teamBuildingSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Dance Embassy Team Building Workshops",
  "description": "Highly personalised corporate team building workshops including Salsa, Zumba, Bollywood, Bellydance, Hip‑Hop, K‑Pop, Meditation, Pilates, African Dance, Kathak and TikTok dance routines.",
  "provider": {
    "@type": "Organization",
    "name": "Dance Embassy",
    "url": "https://www.danceembassy.com/",
    "logo": "https://www.danceembassy.com/static/media/mainlogo.07e7dc24.svg",
    "sameAs": [
      "https://www.youtube.com/c/Danceembassy"
    ],
    "description": "Dance Embassy offers dance & wellness programs, corporate workshops, fitness classes and performances."
  },
  "serviceType": "Corporate Team Building Workshop",
  "category": ["Dance", "Wellness", "Corporate Event"],
  "areaServed": {
    "@type": "Place",
    "name": "Singapore"
  },
  "audience": {
    "@type": "BusinessAudience",
    "audienceType": "Corporate clients"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Team Building Workshop Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "1‑Hour Team Workshop",
        "description": "One dance or wellness session customized for your team.",
        "price": "TBD",
        "priceCurrency": "SGD",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Extended / Multi‑Session Workshops",
        "description": "Customized series of classes over multiple sessions.",
        "price": "TBD",
        "priceCurrency": "SGD",
        "availability": "https://schema.org/InStock"
      }
    ]
  },
  "url": "https://www.danceembassy.com/team-building-workshops/",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://www.danceembassy.com/team-building-workshops/"
  }
}

export const weddingDanceSchema = {
    "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What styles of dance do you offer for wedding routines?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We specialize in Bollywood-fusion and can incorporate elements from Hip-Hop, Latin, Jazz, Contemporary, or Traditional styles to suit your vision."
      }
    },
    {
      "@type": "Question",
      "name": "How far in advance should we start our dance lessons?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's best to start 3–5 months before your wedding. This gives enough time to learn, refine, and feel confident. However, we can also work with tighter timelines."
      }
    },
    {
      "@type": "Question",
      "name": "How many sessions will we need for our first dance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most couples require 4–8 lessons, depending on complexity. We’ll suggest a number based on your schedule and comfort level."
      }
    },
    {
      "@type": "Question",
      "name": "Can we learn if we have no prior dance experience?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Most of our couples are complete beginners. Our instructors are trained to teach step-by-step, building your confidence along the way."
      }
    },
    {
      "@type": "Question",
      "name": "Will the routine be customized to us?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, every routine is choreographed based on your chosen song, theme, comfort level, and desired style—whether romantic, fun, or dramatic."
      }
    },
    {
      "@type": "Question",
      "name": "Can we include our bridal party or parents in the choreography?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes! We offer choreography for group performances, bridal parties, and even flash mobs if you want to involve more people."
      }
    },
    {
      "@type": "Question",
      "name": "How often should we practice outside of lessons?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Practicing 15–30 minutes, about three times a week, helps build muscle memory and confidence. Closer to the event, practice in your wedding shoes."
      }
    },
    {
      "@type": "Question",
      "name": "What should we wear for the lessons?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Wear comfortable clothing and bring your wedding shoes (or similar) to help adjust to the movement and feel."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help us choose a song or create a medley?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we’re happy to suggest songs or help blend multiple tracks for a memorable performance."
      }
    },
    {
      "@type": "Question",
      "name": "What if we need more lessons than we planned for?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Additional sessions can be arranged anytime. We're flexible and here to help you feel stage-ready."
      }
    }
  ]
}
export const kidsDanceSchema = {
    "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What age groups do your kids’ dance classes and parties cater to?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our programs are designed for children of all ages, with classes and party packages tailored to be engaging, age-appropriate, and fun for each group."
      }
    },
    {
      "@type": "Question",
      "name": "What happens at a Kids Dance Party?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dance Embassy’s friendly crew hosts a high-energy, interactive session where kids learn choreography, play dance-based games, and enjoy a complimentary photo and video session to capture the fun moments."
      }
    },
    {
      "@type": "Question",
      "name": "How do I book a dance party or class?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply reach out via our booking form or contact page, select your preferred date and time, and our team will help customize the experience to fit your child's party theme and group size."
      }
    },
    {
      "@type": "Question",
      "name": "What are the pricing and package options?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We offer flexible packages depending on group size and duration. Packages typically include dance instruction, photo/video, and optional add-ons like themed merchandise or experiences. For detailed pricing, please get in touch with our team."
      }
    },
    {
      "@type": "Question",
      "name": "Can you accommodate special themes or customize the party?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! We welcome theme-based requests such as Bollywood, hip-hop, or princess themes, and can tailor music, choreography, and dance games to your celebration."
      }
    },
    {
      "@type": "Question",
      "name": "Where do the parties take place—do you travel or have a studio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We can host the party at our studio or bring the experience to your home or chosen venue. We’ll ensure there’s fun, space, and a group-friendly atmosphere wherever you are."
      }
    },
    {
      "@type": "Question",
      "name": "Is the photo and video session professional quality?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes! Our crew provides a complimentary photo and video session to capture the highlights of the party, with quality good enough to share with family and friends."
      }
    },
    {
      "@type": "Question",
      "name": "What makes Dance Embassy parties unique?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our team specializes in engaging kids through interactive dance, fun games, and multimedia elements like photos and videos—creating memorable experiences full of creativity and excitement."
      }
    }
  ]

}